$(document).ready(function () {
    if($('.banner-list .banner_box').length > 1){  
        $('.banner-list').slick({
            arrows: false,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true
        });
    }
    
    
       $(".product-slider").slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
        {
            breakpoint: 1280,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 4
            }
        },
        {
            breakpoint: 1024,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 2
            }
        },
        {
            breakpoint: 550,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 1
            }
        }
       ]
    });

    $('.review-slider-list').slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
        {
            breakpoint: 1280,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 2
            }
        },
        {
            breakpoint: 800,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 1
            }
        }
       ]
    });


    const CartTotalAmount = document.querySelector("#CartCount .cart_total");
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        const totalInCurrency = cart.total_price / 100;
        const formattedTotal = localizeCurrency(totalInCurrency);
        
        console.log('formattedTotal ',formattedTotal);
        if (CartTotalAmount) {
            CartTotalAmount.innerText = formattedTotal;
        }
    })
    .catch(err => console.error(err));
    
    function localizeCurrency(amount) {
        const locale = window.Shopify.locale;
        const country = window.Shopify.country;
        const currencyCode = window.Shopify.currency.active;

        return new Intl.NumberFormat(`${locale}-${country}`, {
            style: 'currency',
            currency: currencyCode,
        }).format(amount);
    }
    

    async function getCartTotal() {
        const res = await fetch('/cart.js');
        const data = await res.json();
        return data.total_price / 100;
    }

    async function onCartChange() {
        const total = await getCartTotal();
        console.log('cart update total ', total)

        const totalFormatted = localizeCurrency(total);
        console.log('totalFormatted ', totalFormatted)
        if(total == 0) {
            const CartCount = document.querySelector("#CartCount");
            CartCount.classList.remove('hide');
        }
        if (CartTotalAmount) {
            CartTotalAmount.innerText = totalFormatted;
        }
    }

    /* OBSERVER FOR CART PAGE */
    const cartContainer = document.querySelector('.main_cart_page_form');

    if (cartContainer) {
        const observer = new MutationObserver(() => {
            onCartChange();
        });

        observer.observe(cartContainer, {
            childList: true,
            subtree: true,
        });
    }

    document.addEventListener('click', function (e) {
        const atcBtn = e.target.closest('.product-form__controls-group button.product-form__cart-submit');

        if (atcBtn) {
        console.log('🛒 Add to Cart clicked');

        setTimeout(() => {
            onCartChange();
        }, 1000);
        }
    });


});


